export default __webpack_public_path__ + "static/media/badge.f366a902.svg";